import '@platform/ui/ConfirmDialog/ConfirmDialog.css';

const WarningIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="1.5">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

const DeleteIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </svg>
);

export default function ConfirmDialog({
  open,
  icon = 'warning',
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  secondaryLabel,
  variant = 'danger',
  onConfirm,
  onCancel,
  onSecondary,
}) {
  if (!open) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={e => e.stopPropagation()}>
        <div className="confirm-dialog-body">
          <div className="confirm-dialog-icon">
            {icon === 'delete' ? <DeleteIcon /> : <WarningIcon />}
          </div>
          <h3>{title}</h3>
          <p>{message}</p>
        </div>
        <div className="confirm-dialog-actions">
          {secondaryLabel && onSecondary && (
            <button className="confirm-btn danger" onClick={onSecondary}>
              {secondaryLabel}
            </button>
          )}
          {cancelLabel && (
            <button className="confirm-btn neutral" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button className={`confirm-btn ${variant}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
